import React from 'react';
import './App.css';
import { ThemeProvider } from './components/ThemeProvider';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import EngineeringInsights from './components/EngineeringInsights';
import About from './components/About';
import WhatIDo from './components/WhatIDo';
import Skills from './components/Skills';
import InteractiveDemo from './components/InteractiveDemo';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Achievements from './components/Achievements';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen transition-theme">
        <Header />
        <main>
          <Hero />
          <About />
          <WhatIDo />
          <Skills />
          <Experience />
          <Projects />
          <EngineeringInsights />
          <InteractiveDemo />
          <Achievements />
          <Contact />
        </main>
        <Footer />
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
